"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonMarkerStyle = exports.useLikePoi = exports.useDistrict = exports.replaceAll = exports.applyLengthLimit = exports.getRestTitle = exports.stackCheck = exports.bannerStack = exports.setBannerStack = exports.getCloseKey = exports.getNeverKey = exports.getGoogleAds = exports.getNaverMap = exports.getKakaoSDK = exports.getQueryParams = exports.removeRecent = exports.removeCacheResult = exports.setGpsCookie = exports.removeGps = exports.parseRegion = exports.parseAddr = exports.throttle = exports.showIntoView = exports.regionParser = exports.listRandom = exports.goBackHistory = exports.drag = exports.cleanObject = exports.dcImageResource = exports.localConsole = exports.req = void 0;
// Resource
const dcAPI_1 = __importDefault(require("./api/dcAPI"));
exports.req = dcAPI_1.default;
const localConsole_1 = __importDefault(require("./utils/localConsole"));
exports.localConsole = localConsole_1.default;
const imageUrl_1 = __importDefault(require("./resource/imageUrl"));
exports.dcImageResource = imageUrl_1.default;
const cleanObject_1 = __importDefault(require("./utils/cleanObject"));
exports.cleanObject = cleanObject_1.default;
const drag_1 = __importDefault(require("./utils/drag"));
exports.drag = drag_1.default;
const goBackHistory_1 = __importDefault(require("./utils/goBackHistory"));
exports.goBackHistory = goBackHistory_1.default;
const listRandom_1 = __importDefault(require("./utils/listRandom"));
exports.listRandom = listRandom_1.default;
const regionParser_1 = __importDefault(require("./utils/regionParser"));
exports.regionParser = regionParser_1.default;
const showIntoView_1 = __importDefault(require("./utils/showIntoView"));
exports.showIntoView = showIntoView_1.default;
const throttle_1 = require("./utils/throttle");
Object.defineProperty(exports, "throttle", { enumerable: true, get: function () { return throttle_1.throttle; } });
// modules
const useDistrict_1 = require("./hooks/useDistrict");
Object.defineProperty(exports, "parseAddr", { enumerable: true, get: function () { return useDistrict_1.parseAddr; } });
const useDistrict_2 = require("./hooks/useDistrict");
Object.defineProperty(exports, "parseRegion", { enumerable: true, get: function () { return useDistrict_2.parseRegion; } });
const gpsStorageCtrl_1 = require("./modules/gpsStorageCtrl");
Object.defineProperty(exports, "removeGps", { enumerable: true, get: function () { return gpsStorageCtrl_1.removeGps; } });
const gpsStorageCtrl_2 = require("./modules/gpsStorageCtrl");
Object.defineProperty(exports, "setGpsCookie", { enumerable: true, get: function () { return gpsStorageCtrl_2.setGpsCookie; } });
const gpsStorageCtrl_3 = require("./modules/gpsStorageCtrl");
Object.defineProperty(exports, "removeCacheResult", { enumerable: true, get: function () { return gpsStorageCtrl_3.removeCacheResult; } });
// TODO: setRemoveRecent -> removeRecent 로 변경
const recentSearchList_1 = require("./modules/recentSearchList");
Object.defineProperty(exports, "removeRecent", { enumerable: true, get: function () { return recentSearchList_1.removeRecent; } });
const urlHandler_1 = require("./modules/urlHandler");
Object.defineProperty(exports, "getQueryParams", { enumerable: true, get: function () { return urlHandler_1.getQueryParams; } });
// TODO !! : 기존 setQueryParams 사용 하는 모든 페이지 변경해야함
// import { setQueryParams } from "./modules/urlHandler";
// export { setQueryParams };
const getKakaoSDK_1 = __importDefault(require("./modules/getKakaoSDK"));
exports.getKakaoSDK = getKakaoSDK_1.default;
const getNaverMap_1 = require("./modules/getNaverMap");
Object.defineProperty(exports, "getNaverMap", { enumerable: true, get: function () { return getNaverMap_1.getNaverMap; } });
const getGoogleAds_1 = __importDefault(require("./modules/getGoogleAds"));
exports.getGoogleAds = getGoogleAds_1.default;
const bannerCtrl_1 = require("./modules/bannerCtrl");
Object.defineProperty(exports, "getNeverKey", { enumerable: true, get: function () { return bannerCtrl_1.getNeverKey; } });
const bannerCtrl_2 = require("./modules/bannerCtrl");
Object.defineProperty(exports, "getCloseKey", { enumerable: true, get: function () { return bannerCtrl_2.getCloseKey; } });
const bannerCtrl_3 = require("./modules/bannerCtrl");
Object.defineProperty(exports, "setBannerStack", { enumerable: true, get: function () { return bannerCtrl_3.setBannerStack; } });
const bannerCtrl_4 = require("./modules/bannerCtrl");
Object.defineProperty(exports, "bannerStack", { enumerable: true, get: function () { return bannerCtrl_4.bannerStack; } });
const bannerCtrl_5 = require("./modules/bannerCtrl");
Object.defineProperty(exports, "stackCheck", { enumerable: true, get: function () { return bannerCtrl_5.stackCheck; } });
const getRestTitle_1 = __importDefault(require("./modules/getRestTitle"));
exports.getRestTitle = getRestTitle_1.default;
const setMarkerInfo_1 = require("./modules/setMarkerInfo");
Object.defineProperty(exports, "applyLengthLimit", { enumerable: true, get: function () { return setMarkerInfo_1.applyLengthLimit; } });
const replaceAll_1 = require("./modules/replaceAll");
Object.defineProperty(exports, "replaceAll", { enumerable: true, get: function () { return replaceAll_1.replaceAll; } });
// hooks
const useDistrict_3 = require("./hooks/useDistrict");
Object.defineProperty(exports, "useDistrict", { enumerable: true, get: function () { return useDistrict_3.useDistrict; } });
const useLikePoi_1 = __importDefault(require("./hooks/useLikePoi"));
exports.useLikePoi = useLikePoi_1.default;
// styles
const CommonMarkerStyle_1 = __importDefault(require("./components/styles/CommonMarkerStyle"));
exports.CommonMarkerStyle = CommonMarkerStyle_1.default;
